import React, { useState, useEffect } from 'react';
import { Drawer, Checkbox, Radio } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'components/Button';

import '../userTableV2.css';

const ACCESS_MODULES = [
    'Staff management',
    'User access management',
    'Student management',
    'Marketplace CRM',
    'Fee management',
    'Course management',
    'Marketplace settings',
    'Schedule',
    'Attendance management',
    'Leave management',
    'Holiday management',
    'Library',
    'Library access management',
    'Tests',
    'aulas care',
    'Announcements',
];

const CreateAccessDrawer = ({
    open, onClose, onCreate, onUpdate, mode = 'create', editAccess = null,
}) => {

    const isEditMode = mode === 'edit';
    const [accessName, setAccessName] = useState('');
    const [permissions, setPermissions] = useState({});

    useEffect(() => {
        if (!open) return;

        if (isEditMode && editAccess) {

            setAccessName(
                editAccess.accessName ||
                editAccess.name ||
                ''
            );

            setPermissions(
                editAccess.permissions || {}
            );

        } else {

            // CREATE MODE
            setAccessName('');
            setPermissions({});

        }

    }, [open, isEditMode, editAccess]);

    const handlePermissionChange = (module, checked) => {
        setPermissions((prev) => ({
            ...prev,
            [module]: {
                enabled: checked,
                mode: checked
                    ? prev[module]?.mode || 'View'
                    : '',
            },
        }));
    };

    const handleModeChange = (module, mode) => {
        setPermissions((prev) => ({
            ...prev,
            [module]: {
                enabled: true,
                mode,
            },
        }));
    };

    const handleSubmit = () => {

        const trimmedName = accessName.trim();

        if (!trimmedName) return;


        const payload = {
            ...(isEditMode && {
                id: editAccess?.id,
            }),

            accessName: trimmedName,
            permissions,
        };


        if (isEditMode) {

            onUpdate?.(payload);

        } else {

            onCreate?.(payload);

        }

        onClose();
    };

    return (
        <Drawer
            visible={open}
            placement="right"
            width="32%"
            onClose={onClose}
            // destroyOnClose
            closable={false}
            maskClosable={true}
            className="create-access-drawer"
            bodyStyle={{
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
            }}
        >
            {/* HEADER */}

            <div className="create-access-header">

                <div className="create-access-title">
                   { isEditMode ? 'Edit access' : 'Create access' }
                </div>

                {/* <CloseOutlined
                    onClick={onClose}
                    className="create-access-close"
                /> */}

            </div>


            {/* BODY */}

            <div className="create-access-body">

                {/* ACCESS NAME */}

                <div className="access-name-field">

                    <label> Access name </label>

                    <input
                        value={accessName}
                        onChange={(e) =>
                            setAccessName(e.target.value)
                        }
                        placeholder="Access name"
                    />

                </div>


                {/* MANAGE ACCESS */}

                <div className="manage-access-label">
                    Manage access
                </div>


                {/* PERMISSIONS */}

                <div className="create-access-list">

                    {ACCESS_MODULES.map((module) => {

                        const permission =
                            permissions[module] || {
                                enabled: false,
                                mode: '',
                            };

                        const checked =
                            !!permission.enabled;

                        const selectedMode  =
                            permission.mode || undefined;

                        return (
                            <div
                                key={module}
                                className="create-access-row"
                            >

                                {/* CHECKBOX */}

                                <div className="create-access-checkbox">

                                    <Checkbox
                                        checked={checked}
                                        onChange={(e) =>
                                            handlePermissionChange(
                                                module,
                                                e.target.checked
                                            )
                                        }
                                    >
                                        <span className="create-access-module-label">
                                            {module}
                                        </span>
                                    </Checkbox>

                                </div>


                                {/* VIEW / EDIT */}

                                <div className="create-access-radios">

                                    <Radio
                                        checked={selectedMode === 'View'}
                                        onChange={() =>
                                            handleModeChange(
                                                module,
                                                'View'
                                            )
                                        }
                                    >
                                        View
                                    </Radio>

                                    <Radio
                                        checked={selectedMode === 'Edit'}
                                        onChange={() =>
                                            handleModeChange(
                                                module,
                                                'Edit'
                                            )
                                        }
                                    >
                                        Edit
                                    </Radio>

                                </div>

                            </div>
                        );
                    })}

                </div>

            </div>


            {/* FOOTER */}

            <div className="create-access-footer">

                <button
                    type="button"
                    className="create-access-cancel"
                    onClick={onClose}
                >
                    CANCEL
                </button>

                <button
                    type="button"
                    className="create-access-create"
                    disabled={!accessName.trim()}
                    onClick={handleSubmit}
                >
                    {isEditMode ? 'SAVE' : 'CREATE'}
                </button>

            </div>

        </Drawer>
    );
};

export default CreateAccessDrawer;